<template>
  <div>
    <serene-cards v-for="(aCard, i) in sereneCards" :card="aCard" :key="i">
      {{ aCard }}
    </serene-cards>
  </div>
</template>

<script>
import SereneCards from "./card";
export default {
  name: "Display_Serene",
  components: {
    SereneCards
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    /*this.sound = await import('@/assets/audio/letitbereal.mp4');
      this.audio = new Audio(this.sound);
      this.audio.play();*/
    if (!this.audio) {
      this.audio = new Audio(
        "https://familyheartbeatcare.firebaseapp.com/assets/audio/NatureSounds_4.mp4"
      );
      //  this.audioDuration = this.getDuration(this.audio.duration);
      let that = this;
      /*this.audio.addEventListener("updateListener", function() {
           that.audioCurrentTime = that.audio.currentTime.toFixed();
         });*/
    }
    this.audio.play();
    //this.audio.pause();
  },
  computed: {},
  methods: {
    getDuration(seconds) {
      let measuredTime = new Date(null);
      measuredTime.setSeconds(seconds); // specify value of SECONDS
      return measuredTime.toISOString().substr(11, 8);
    }
  },
  data() {
    return {
      sound: null,
      audio: null,
      audioDuration: null,
      sereneCards: [
        {
          name: "1",
          title: "Let It Be Real",
          artist: "Debra Snipes",
          imgURL: "1.png",
          audio: "",
          isFlipped: false
        },
        {
          name: "1",
          title: "Let It Be Real",
          artist: "Debra Snipes",
          imgURL: "1.png",
          audio: "",
          isFlipped: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
  min-height: 120px;
  cursor: pointer;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.matched {
  opacity: 0.3;
}
</style>
